/**
 * Encode a list of episode ids into a URL-safe token, and decode back.
 * We just join the ids with commas and base64url-encode — no compression
 * needed because the ids are short uuids and the max library is small.
 */

const enc = (bytes) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

const dec = (s) => {
  const padded = s.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - (s.length % 4)) % 4);
  const bin = atob(padded);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
  return bytes;
};

export const encodePlaylist = (ids = []) => {
  if (!ids.length) return '';
  const text = ids.join(',');
  const bytes = new TextEncoder().encode(text);
  return enc(bytes);
};

export const decodePlaylist = (token) => {
  if (!token) return [];
  try {
    const bytes = dec(token);
    const text = new TextDecoder().decode(bytes);
    return text.split(',').filter((s) => s && s.length >= 8);
  } catch {
    return [];
  }
};

export const buildShareUrl = (ids = []) => {
  const token = encodePlaylist(ids);
  if (!token) return '';
  return `${window.location.origin}/library?p=${token}`;
};

export const buildRssUrl = (ids = []) => {
  const base = process.env.REACT_APP_BACKEND_URL;
  if (!base || !ids.length) return '';
  return `${base}/api/playlist/rss?ids=${encodeURIComponent(ids.join(','))}`;
};
